/* BLOCKS V2.1 — variant-aware Shopify configurator with explicit Liquid data. */
(function () {
  'use strict';
  const colorMap={
    black:'#222222',noir:'#222222',white:'#e9e9e5',blanc:'#e9e9e5',ivory:'#eeeadf',cream:'#f0e5d2',beige:'#ddc1a4',
    grey:'#9e9e9e',gray:'#9e9e9e',gris:'#9e9e9e',blue:'#7199cb',bleu:'#7199cb',navy:'#23385c',red:'#d83c41',rouge:'#d83c41',
    orange:'#f49c45',yellow:'#f4da4b',jaune:'#f4da4b',lime:'#d9ff48',fluo:'#d9ff48',green:'#70a46f',vert:'#70a46f',
    purple:'#a28ac9',violet:'#a28ac9',pink:'#f084ad',rose:'#f084ad',silver:'#b4b4b4',metal:'#aaa7a1',brown:'#987458'
  };
  function shade(value){
    const normalized=String(value||'').toLowerCase();
    // BLOCKS-specific swatch shades; keeps existing product options unchanged.
    if(normalized.includes('army blue'))return '#243D63';
    if(normalized.includes('sapphire blue'))return '#307FD7';
    if(normalized.includes('electric indigo'))return '#713B9D';
    for(const [key,color] of Object.entries(colorMap))if(normalized.includes(key))return color;
    return '#888888';
  }
  function money(cents){
    const value=Number(cents);
    if(!Number.isFinite(value))return '—';
    return new Intl.NumberFormat('fr-TN',{minimumFractionDigits:0,maximumFractionDigits:3}).format(value/100)+' DT';
  }
  function formatPrice(variant){return variant?.price_formatted||money(variant?.price);}
  function optionNames(product){
    return Array.isArray(product?.options) ? product.options.map(o=>typeof o==='string'?o:String(o?.name||'')) : [];
  }
  function findOption(product,kind){
    const names=optionNames(product);
    return names.findIndex(name=>kind==='body'?/(body|corps)/i.test(name):/(caps?|embouts?|tpu)/i.test(name));
  }
  function valuesFor(product,index){
    return [...new Set((product?.variants||[]).map(v=>v.options?.[index]).filter(v=>v!==undefined&&v!==null&&String(v)!==''))].map(String);
  }
  function initNav(){
    if(document.documentElement.dataset.blocksNavInitialized)return;
    document.documentElement.dataset.blocksNavInitialized='true';
    document.addEventListener('click',event=>{
      document.querySelectorAll('.blocks-nav__menu[open]').forEach(menu=>{
        if(!menu.contains(event.target)||event.target.closest('a'))menu.open=false;
      });
    });
    document.addEventListener('keydown',event=>{
      if(event.key==='Escape')document.querySelectorAll('.blocks-nav__menu[open]').forEach(menu=>menu.open=false);
    });
  }
  function initConfigurator(root){
    if(root.dataset.initialized==='true')return;
    const dataEl=root.querySelector('[data-config-products]');
    // Optional 3D imagery for BIG and MINI. Shopify retains variants, prices, inventory and cart.
    const visualsEl=root.querySelector('[data-big-visuals]');
    let bigVisuals={};
    try { bigVisuals=JSON.parse(visualsEl?.textContent||'{}'); }
    catch(error) { console.warn('BLOCKS: Big 3D image mapping could not load',error); }
    const miniVisualsEl=root.querySelector('[data-mini-visuals]');
    let miniVisuals={};
    try { miniVisuals=JSON.parse(miniVisualsEl?.textContent||'{}'); }
    catch(error) { console.warn('BLOCKS: Mini 3D image mapping could not load',error); }
    const status=root.querySelector('[data-status]');
    const priceEl=root.querySelector('[data-price]');
    const btn=root.querySelector('[data-add]');
    let products;
    try {
      products=JSON.parse(dataEl?.textContent||'{}');
    } catch(error){
      status.textContent='Product configuration could not load. Check the Shopify products.';
      console.error('BLOCKS: product JSON is invalid',error);
      return;
    }
    root.dataset.initialized='true';
    const wrap=root.closest('.blocks-shop');
    const panel=wrap.querySelector('[data-cart-panel]');
    const image=root.querySelector('[data-product-image]');
    const sculpture=root.querySelector('[data-fallback-visual]');
    const photoCaption=root.querySelector('.blocks-config__stage-fallback');
    const visualSize=root.querySelector('[data-visual-size]');
    const visualColors=root.querySelector('[data-visual-colors]');
    const sizeName=root.querySelector('[data-size-name]');
    const groups={body:root.querySelector('[data-option-group="body"]'),caps:root.querySelector('[data-option-group="caps"]')};
    const extra=root.querySelector('[data-extra-options]');
    let size=products.big?'big':(products.mini?'mini':'big');
    let choices={};
    let currentProduct=null;
    let selectedVariant=null;
    let previousFocus=null;

    function setImage(url,alt){
      if(!url){image.hidden=true;sculpture.hidden=false;photoCaption.textContent='Preview illustration';return;}
      image.onerror=()=>{image.hidden=true;sculpture.hidden=false;photoCaption.textContent='Preview illustration';};
      image.src=url;image.alt=alt||'Blocks';image.hidden=false;sculpture.hidden=true;
      photoCaption.textContent='';
    }
    function refreshSelected(){
      currentProduct=products[size];
      root.querySelectorAll('[data-size]').forEach(el=>{
        el.disabled=!products[el.dataset.size];
        const active=el.dataset.size===size;
        el.classList.toggle('is-selected',active);
        el.setAttribute('aria-pressed',String(active));
      });
      visualSize.textContent=size.toUpperCase()+' BLOCKS';
      if(!currentProduct || !Array.isArray(currentProduct.variants) || !currentProduct.variants.length){
        selectedVariant=null;btn.disabled=true;priceEl.textContent='—';sizeName.textContent='—';
        status.textContent='Assign available Big and Mini products in the section settings.';
        setImage(null);
        return;
      }
      selectedVariant=currentProduct.variants.find(v=>(v.options||[]).every((value,index)=>String(value)===String(choices[index])))||null;
      const representative=selectedVariant||currentProduct.variants.find(v=>v.available)||currentProduct.variants[0];
      priceEl.textContent=formatPrice(representative);
      sizeName.textContent=(size==='big'?'Big':'Mini')+' · '+formatPrice(representative);
      btn.disabled=!selectedVariant||!selectedVariant.available;
      status.textContent=selectedVariant?(selectedVariant.available?'Ready to add to your bag.':'This combination is sold out.'):'This combination is unavailable.';
      const bodyIndex=findOption(currentProduct,'body');
      const capsIndex=findOption(currentProduct,'caps');
      const bodyValue=bodyIndex>=0?choices[bodyIndex]:'Body';
      const capsValue=capsIndex>=0?choices[capsIndex]:'Caps';
      root.style.setProperty('--chosen-body',shade(bodyValue));
      root.style.setProperty('--chosen-caps',shade(capsValue));
      visualColors.textContent=String(bodyValue).toUpperCase()+' / '+String(capsValue).toUpperCase();
      for(const [kind,group] of Object.entries(groups)){
        const index=kind==='body'?bodyIndex:capsIndex;
        if(index<0)continue;
        group.querySelector('[data-selected-name]').textContent=choices[index]||'—';
        group.querySelectorAll('[data-value]').forEach(control=>{
          const active=control.dataset.value===choices[index];
          control.classList.toggle('is-selected',active);
          control.setAttribute('aria-pressed',String(active));
          const possible={...choices,[index]:control.dataset.value};
          const available=currentProduct.variants.some(v=>v.available&&(v.options||[]).every((val,i)=>String(val)===String(possible[i])));
          control.classList.toggle('is-unavailable',!available);
          control.setAttribute('aria-label',`${kind} color: ${control.dataset.value}${!available?' (unavailable)':''}`);
        });
      }
      // Show the 3D render for the selected Body/Caps pair without changing variant data.
      let selectedImage=representative?.featured_image||currentProduct.featured_image;
      if(selectedVariant && bodyIndex>=0 && capsIndex>=0){
        const body=String(selectedVariant.options?.[bodyIndex]||'');
        const caps=String(selectedVariant.options?.[capsIndex]||'');
        if(size==='big'){
          selectedImage=bigVisuals[body]?.[caps]||selectedImage;
        }else if(size==='mini'){
          const bodyName=body.toLowerCase();
          const capsName=caps.toLowerCase();
          const miniBody=bodyName.includes('indigo')?'indigo':
            /sapphire|saphire|sapbhire/.test(bodyName)?'sapphire':
            bodyName.includes('army')&&bodyName.includes('blue')?'army':
            /red|rouge/.test(bodyName)?'red':
            /black|noir/.test(bodyName)?'black':null;
          const miniCaps=/yellow|jaune/.test(capsName)?'yellow':
            /orange/.test(capsName)?'orange':
            /white|blanc/.test(capsName)?'white':
            /red|rouge/.test(capsName)?'red':
/black|noir/.test(capsName)?'black':null;
          if(miniBody && miniCaps) selectedImage=miniVisuals[miniBody]?.[miniCaps]||selectedImage;
        }
      }
      setImage(selectedImage,currentProduct.title+' — '+(representative?.title||''));
    }
    function renderOptions(){
      currentProduct=products[size];
      const options=optionNames(currentProduct);
      const first=currentProduct?.variants?.find(v=>v.available)||currentProduct?.variants?.[0];
      choices={};
      (first?.options||[]).forEach((value,index)=>choices[index]=String(value));
      const indices={body:findOption(currentProduct,'body'),caps:findOption(currentProduct,'caps')};
      for(const [kind,group] of Object.entries(groups)){
        const index=indices[kind];
        group.hidden=index<0;
        const container=group.querySelector('[data-option-values]');container.replaceChildren();
        if(index<0)continue;
        valuesFor(currentProduct,index).forEach(value=>{
          const button=document.createElement('button');button.type='button';
          button.className='blocks-config__swatch';
          button.style.setProperty('--swatch',shade(value));
          button.dataset.value=value;button.title=value;
          button.addEventListener('click',()=>{choices[index]=value;refreshSelected();});
          container.appendChild(button);
        });
      }
      extra.replaceChildren();
      options.forEach((name,index)=>{
        if(Object.values(indices).includes(index))return;
        const wrapper=document.createElement('label');wrapper.className='blocks-config__select-row';
        const label=document.createElement('span');label.textContent=name;
        const select=document.createElement('select');select.setAttribute('aria-label',name);
        valuesFor(currentProduct,index).forEach(value=>{
          const item=document.createElement('option');item.value=value;item.textContent=value;item.selected=choices[index]===value;select.appendChild(item);
        });
        select.addEventListener('change',()=>{choices[index]=select.value;refreshSelected();});
        wrapper.append(label,select);extra.appendChild(wrapper);
      });
      // A default-only variant has no meaningful options, but is still purchasable.
      refreshSelected();
    }
    function chooseSize(next){if(!products[next])return;size=next;renderOptions();}
    root.querySelectorAll('[data-size]').forEach(el=>el.addEventListener('click',()=>chooseSize(el.dataset.size)));
    if(products.big||products.mini)chooseSize(size);else refreshSelected();

    function dismissPanel(){panel.hidden=true;document.body.style.overflow='';previousFocus?.focus();}
    function showPanel(){previousFocus=document.activeElement;panel.hidden=false;document.body.style.overflow='hidden';panel.querySelector('.blocks-cart-panel__close')?.focus();}
    document.addEventListener('blocks:open-confirmation', showPanel);
    panel.querySelectorAll('[data-dismiss-cart]').forEach(el=>el.addEventListener('click',dismissPanel));
    document.addEventListener('keydown',event=>{if(event.key==='Escape'&&!panel.hidden)dismissPanel();});
    root.querySelector('[data-config-form]').addEventListener('submit',async event=>{
      event.preventDefault();
      if(!selectedVariant||!selectedVariant.available)return;
      btn.disabled=true;status.textContent='Adding to bag…';
      const previous=btn.innerHTML;btn.textContent='Adding…';
      try{
        const path=window.Shopify?.routes?.root||'/';
        const response=await fetch(path+'cart/add.js',{
          method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({items:[{id:selectedVariant.id,quantity:1}]})
        });
        const result=await response.json();
        if(!response.ok)throw new Error(result.description||result.message||'Unable to add this product.');
        status.textContent='Added to your bag.';
        try{
          const count=await fetch(path+'cart.js',{credentials:'same-origin'}).then(r=>r.json());
          document.querySelectorAll('[data-blocks-cart-count]').forEach(el=>el.textContent='('+count.item_count+')');
        }catch(e){/* Cart added; count refresh is noncritical. */}
        showPanel();
      }catch(error){status.textContent=error.message||'Please try again.';}
      finally{btn.innerHTML=previous;btn.disabled=!selectedVariant||!selectedVariant.available;}
    });
  }
  function init(scope=document){
    initNav();
    if(scope.matches?.('[data-blocks-config]'))initConfigurator(scope);
    scope.querySelectorAll('[data-blocks-config]').forEach(initConfigurator);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(),{once:true});
  else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  // BLOCKS V2 — Limited Editions: Add to Bag
document.addEventListener('click', async (event) => {
  const button = event.target.closest('[data-blocks-limited-add]');
  if (!button || button.disabled) return;

  event.preventDefault();
  event.stopPropagation();

  const variantId = Number(button.dataset.blocksLimitedAdd);
  if (!variantId) return;

  const originalContent = button.innerHTML;
  button.disabled = true;
  button.textContent = 'ADDING...';

  try {
    const path = window.Shopify?.routes?.root || '/';

    const response = await fetch(path + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }]
      })
    });

    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.description || 'Unable to add product');
    }

    try {
      const cartResponse = await fetch(path + 'cart.js', {
        credentials: 'same-origin'
      });
      const cart = await cartResponse.json();

      document.querySelectorAll('[data-blocks-cart-count]').forEach(el => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
      console.warn('Cart count could not be refreshed', error);
    }

    button.textContent = 'ADDED TO BAG';
document.dispatchEvent(new Event('blocks:open-confirmation'));
  } catch (error) {
    console.error(error);
    button.textContent = 'TRY AGAIN';
  } finally {
    setTimeout(() => {
      button.innerHTML = originalContent;
      button.disabled = false;
    }, 1500);
  }
});
})();
